import { render, staticRenderFns } from "./Translations.vue?vue&type=template&id=a2da7554&scoped=true&"
import script from "./Translations.vue?vue&type=script&lang=js&"
export * from "./Translations.vue?vue&type=script&lang=js&"
import style0 from "./Translations.vue?vue&type=style&index=0&id=a2da7554&lang=scss&scoped=true&"
import style1 from "./Translations.vue?vue&type=style&index=1&lang=scss&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "a2da7554",
  null
  
)

export default component.exports